import React from "react";

// Primary uses the solid fill token (--accent-fill, midnight navy) with white
// --accent-ink on top, NOT --accent. Keeping fills on their own token is what
// lets the palette be swapped without re-auditing every button: --accent is
// tuned to be readable as text, which is a different constraint. See the
// two-accent-token note in index.css.
const VARIANTS = {
  primary:
    "bg-[var(--accent-fill)] text-[var(--accent-ink)] hover:bg-[var(--accent-fill-hover)] hover:-translate-y-px hover:shadow-[0_4px_16px_color-mix(in_srgb,var(--accent-fill)_45%,transparent)]",
  ghost:
    "bg-[var(--panel)] border-[var(--primary)] text-[var(--primary)] hover:bg-[var(--panel-2)]",
  danger:
    "bg-[var(--danger)] text-white hover:-translate-y-px hover:shadow-[0_4px_16px_color-mix(in_srgb,var(--danger)_35%,transparent)]",
  success:
    "bg-[var(--ok)] text-white hover:-translate-y-px hover:shadow-[0_4px_16px_color-mix(in_srgb,var(--ok)_35%,transparent)]",
};

const Button = ({
  as: Tag = "button",
  variant = "primary",
  size = "md",
  block = false,
  disabled = false,
  className = "",
  children,
  ...props
}) => {
  const sizeCls = size === "lg" ? "h-12 px-[22px] text-[15px]" : "h-11 px-[18px] text-sm";
  const disabledCls = disabled ? "!bg-[var(--panel-2)] !text-[var(--dim)] !border-[var(--line)] cursor-not-allowed" : "";
  return (
    <Tag
      disabled={Tag === "button" ? disabled : undefined}
      className={[
        "inline-flex items-center justify-center gap-2 rounded-[10px] font-semibold border border-transparent",
        "transition-transform duration-75 active:translate-y-px",
        VARIANTS[variant],
        sizeCls,
        block ? "w-full" : "",
        disabledCls,
        className,
      ].join(" ")}
      {...props}
    >
      {children}
    </Tag>
  );
};

export default Button;
